<template>
  <div class="categories-page">
    <van-search
  v-model="value"
  disabled
  shape="round"
  placeholder="请输入搜索关键词"
  @click="gotosearch"
>
   <template #left>
      <van-icon @click.stop="goback"  style="margin-right: 10px;" name="arrow-left" />
    </template>
    </van-search>
    <div class="categories-x">

      <div
          @click="activeCategoryXClick(item.optionValue)"
          :class="['item', { active: activeCategoryX == item.optionValue }]"
          :key="item.optionValue"
          v-for="item in categoryOne"
      >
        {{ item.optionDesc }}
      </div>
    </div>
    <div class="main">
      <div class="categories-y">
        <div
            @click="activeCategoryYClick(item.tagKey)"
            :class="['item', { active: activeCategoryY == item.tagKey }]"
            :key="item.tagValue"
            v-for="item in categoryTwo"
        >
          {{ item.tagKey }}
        </div>
      </div>
      <div class="content">
        <van-empty v-if="series.length==0" description="没有相应的内容"/>
        <div @click="linkUrl(item)" :key="item.id" class="series" v-for="item in series">
          <img :src="item.imageUrl"/>
          <div class="tit">{{ item.tagValue }}</div>
        </div>
      </div>
    </div>
    <Footer safe-area-inset-bottom></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";

export default {
  name: "CategoryPage",
  components: {Footer},
  data() {
    return {
      pageSize: 20,
      pageNum: 1,
      series: [],
      activeCategoryY: "",
      activeCategoryX: "",
      categoryOne: [],
      categoryTwo: [],
    };
  },

  mounted() {
    this.activeCategoryY = this.$route.query.series;
    this.activeCategoryX = this.$route.query.pinlei;
    this.getCategoryOneData('init'); //请求左侧数据源
    // this.getCategoryTwoData(); //请求右侧数据源
    // this.getSeriesData();

    this.$nextTick(()=>{
      let dom = document.getElementsByClassName('categories-page')
      if(dom!=null) {
        dom.scrollTop = 0
      }
    })
  },
  methods: {
    gotosearch(){
        this.$router.push('./searchpage');
    },
    linkUrl(item) {
      if(this.activeCategoryX!='MianLiao'){
       this.$router.push('./category-style?tagValue='+item.tagValue+'&tagId=' + item.id + '&productType=' + this.activeCategoryX);
      }else{
         this.$router.push('./category-style-mianliao?tagValue='+item.tagValue+'&tagId=' + item.id + '&productType=' + this.activeCategoryX);
      }
     
    },
    activeCategoryYClick(id) {
      this.pageNum = 1;
      this.activeCategoryY = id;
      // const pinlei = window.location.hash.split("pinlei=")[1] ? window.location.hash.split("pinlei=")[1].split("&")[0] : ''
      this.$router.replace('./category?series=' + id + "&pinlei=" + this.activeCategoryX);
      this.getSeriesData(id);
    },
    activeCategoryXClick(id) {
      this.pageNum = 1;
      this.activeCategoryX = id;
      this.series = [];
      const series = window.location.hash.split("series=")[1] ? window.location.hash.split("series=")[1].split("&")[0] : ''
      this.$router.replace('./category?pinlei=' + id + "&series=" + series);
      this.activeCategoryY =undefined
      this.getCategoryTwoData(this.activeCategoryX);
    },
    getCategoryTwoData(id) {  //请求系列接口
      this.$http.post("/public/tags", id).then(res => {
        this.categoryTwo = res || []
        this.activeCategoryY = this.activeCategoryY ||res[0].tagKey
        this.getSeriesData()
      });

     
    },
    getCategoryOneData(type = 'normal') {  //请求品类接口

      this.$http.post("/public/productTypes", {}).then(res => {
        this.categoryOne = res;
        this.activeCategoryX = this.activeCategoryX||res[0].optionValue || ''
        this.getCategoryTwoData(this.activeCategoryX)
      });
      
    },
    goback(){
      history.go(-1)
    },
    getSeriesData() {
      let sss = this.categoryTwo.find((item) => item.tagKey == this.activeCategoryY) || {}
      this.series = sss.tags || []

    },
  },
};
</script>
<style  scoped>

.categories-page {
  background: var(--bg-color);
  min-height: 100vh;
}

.categories-x {
  display: flex;
  padding: 10px;
  background: #fff;
  font-size: 14px;
  overflow-x: auto;
  padding-left: 80px;
}

.main {
  display: flex;
  height: calc(100vh - 100px);
  overflow-y: hidden;
  align-items: flex-start;
}

.categories-x .item {
  flex: 0 0 70px;
  text-align: center;
}

.categories-y {
  flex: 0 0 80px;
  background: #fff;
  /* padding: 0 10px; */
  font-size: 14px;
  height: 100%;
}

.categories-y .item {
  padding: 8px 5px;
  text-align: center;
}

.content {
  margin-top: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: calc(100% - 80px);
  overflow-x: hidden;
  flex-wrap: wrap;
  margin-left: 10px;
  overflow-y: auto;
  max-height: calc(100vh - 200px);
}

.content .series {
  flex: 0 0 calc(33.33% - 10px);
  background: #fff;
  /* height: 190px; */
  margin-right: 10px;
  margin-bottom: 10px;
  font-size: 12px;
}

.content .series:nth-child(3n + 3) {
  margin-right: 0px;
}

.content .series img {
  max-width: 100%;
}

.content .series .tit {
  text-align: center;
  padding: 5px;
}
</style>
